export default {
  routes: [
    {
      name: 'logistics',
      path: '/directory/logistics',
      component: () => import('./views/TheLogistics.vue'),

    },

    {
      name: 'logistic',
      path: '/directory/logistics/:uuid',
      component: () => import('./views/TheLogistic.vue'),
    },
  ]
}
